import React, { useEffect } from "react";
import PageLayout from "../components/ui/PageLayout";

const TermsOfServicePage: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-gray-900 text-white min-h-screen">
      <PageLayout>
        <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-8 text-center">
            Terms of Service
          </h1>
          <div className="space-y-6">
            <h2 className="text-2xl font-semibold">1. Introduction</h2>
            <p>
              Welcome to DreamWorld. These Terms of Service ("Terms") govern
              your use of our application. By using DreamWorld, you agree to
              these Terms.
            </p>

            <h2 className="text-2xl font-semibold">2. User Accounts</h2>
            <p>
              To use DreamWorld, you must create an account using your Pi
              Network username. You are responsible for maintaining the
              confidentiality of your account and are fully responsible for all
              activities that occur under your account.
            </p>

            <h2 className="text-2xl font-semibold">3. User Conduct</h2>
            <p>You agree not to:</p>
            <ul className="list-disc list-inside space-y-2">
              <li>
                Use the application for any illegal or unauthorized purpose.
              </li>
              <li>
                Interfere with or disrupt the application or servers or
                networks connected to the application.
              </li>
              <li>
                Attempt to gain unauthorized access to the application or
                other users' accounts.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold">4. Intellectual Property</h2>
            <p>
              All content and materials available on DreamWorld, including but
              not limited to text, graphics, website name, code, images, and
              logos are the intellectual property of DreamWorld and are
              protected by applicable copyright and trademark law.
            </p>

            <h2 className="text-2xl font-semibold">5. Termination</h2>
            <p>
              We may terminate or suspend your account at any time, without
              prior notice or liability, for any reason, including if you
              breach these Terms.
            </p>

            <h2 className="text-2xl font-semibold">
              6. Disclaimer of Warranties
            </h2>
            <p>
              The application is provided "as is" and "as available" without
              any warranties of any kind, either express or implied. We do not
              warrant that the application will be uninterrupted or error-free.
            </p>

            <h2 className="text-2xl font-semibold">
              7. Limitation of Liability
            </h2>
            <p>
              In no event shall DreamWorld be liable for any indirect,
              incidental, special, consequential, or punitive damages,
              including but not limited to, loss of profits, data, use,
              goodwill, or other intangible losses.
            </p>

            <h2 className="text-2xl font-semibold">
              8. Governing Law
            </h2>
            <p>
              These Terms shall be governed and construed in accordance with
              the laws of the jurisdiction in which the company is based,
              without regard to its conflict of law provisions.
            </p>

            <h2 className="text-2xl font-semibold">
              9. Changes to These Terms
            </h2>
            <p>
              We reserve the right to modify or replace these Terms at any
              time. We will provide notice of any changes by posting the new
              Terms on this page.
            </p>

            <h2 className="text-2xl font-semibold">10. Contact Us</h2>
            <p>
              If you have any questions about these Terms, please contact us at{" "}
              <a
                href="mailto:nikiemaadama249@gmail.com"
                className="text-blue-400 hover:underline"
              >
                nikiemaadama249@gmail.com
              </a>
              .
            </p>
          </div>
        </div>
      </PageLayout>
    </div>
  );
};

export default TermsOfServicePage;